export const API_DATA_MESSAGES = {
  1: {
    responseCode: '01',
    type: 'warning',
    message: 'Por definir',
  },
  2: {
    responseCode: '02',
    type: 'warning',
    message: 'El cliente buscado no existe',
  },
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};
